import { get } from "../http-client/client";
import { ApiResponse } from "../http-client/Response";

export interface OrganizationCost {
  /** YYYY-MM */
  month: string;
  organizationName: string;
  currency: "SEK";
  ceilingSek: number | null;
  spentSek: number;
  percentOfCeiling: number | null;
  projectedSek: number | null;
  daily: { date: string; costSek: number }[];
  byCategory: { category: string; costSek: number }[];
  byUser: { userId: string | null; name: string; email: string; costSek: number }[];
  previousMonths: { month: string; costSek: number }[];
  sekPerUsd: number;
}

/** The caller's organization (admins only) */
export const getOrganizationCost = (month?: string): Promise<ApiResponse<OrganizationCost>> =>
  get(month ? `/cost?month=${month}` : `/cost`, null);
